import React from "react";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";
import { TextareaAutosize } from "@material-ui/core";

class Product extends React.Component {
  initialState = {
    id: this.props.match.params["id"],
    principio_activo_temp: false,
    especies_restringidas: {
      principio_activo: [],
      excipiente: [],
    },
    especies_restringidas_aux: {
      principio_activo: [],
      excipiente: [],
    },
    categorias_restringidas: [],
    categorias_restringidas_listadas: [],
    especies_restringidas_listadas: [],
    especies_restringido_alimento_animal: [],
    cat_ingrediente: [],
    cat_ingredientes_ric: [],
    especies_sin_cat: [],
    options_ingredientes_aux: [],
    excipiente_temp: false,
    tipo_producto_id: this.props.match.params["tipo_producto_id"],
    nombre_comercial: "",
    nombre_comun: "",
    ingredientes_listados_restringidos: [],
    options_categoria_aux: [],
    grupo_ingrediente_id: "",
    clase_producto_id: "",
    categorizacion_oficial_id: "",
    uso: "", //indicaciones
    preparacion_extemporanea: "",
    precauciones_generales: "",
    precauciones_uso: "",
    precauciones_almacenamiento: "",
    caducidad_producto: "",
    medida_tiempo_id: "",
    pais_origen_id: "",
    forma_farmaceutica_id: "",
    tipo_producto_veterinario_id: "1",
    observaciones: "",
    tomo: "",
    tiempo: "",
    fabricante_id: "",
    establecimiento_id: "",
    titular_id: "",
    propiedades_inmunologicas: "",
    validez_preparacion: "",
    instrucciones_uso: "",
    clasificacion_id: "",
    //ACTIVO
    principio_activo: {
      principio_activo_id: "",
      principio_activo_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    principios_activos: [],
    //EXCIPIENTE
    excipiente: {
      excipiente_id: "",
      excipiente_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    excipientes: [],
    //DOSIS
    dosis_especie: {
      dosis: "",
      especie_id: "",
      especie_name: "",
      tiene_categoria: false,
      categoria_id: "",
      categoria_name: "",
    },
    dosis: [],
    //DESCARTE
    descarte: {
      periodo: "",
      especie_prod_id: "",
      especie_prod_name: "",
      medida_tiempo_id: "",
      medida_tiempo_name: "",
    },
    descartes: [],
    //EMPAQUE
    empaque: {
      empaque_id: "",
      empaque_name: "",
      //presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      presentacion_unidad_medida_name: "",
    },
    empaques: [],
    //COMPOSICION BIOLOGICA
    composicion_biologica: {
      composicion_biologica_id: "",
      composicion_biologica_name: "",
      titulo_unidad_medida: "",
    },
    composiciones_biologicas: [],
    //COMPOSICION QUIMICA
    composicion_quimica: {
      composicion_quimica_id: "",
      composicion_quimica_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    composiciones_quimicas: [],
    //MODO EMPLEO
    modo_empleo: {
      modo_empleo: "",
      especie_id: "",
      especie_name: "",
      tiene_categoria: false,
      categoria_id: "",
      categoria_name: "",
    },
    modos_empleo: [],
    //COMPONENTE
    componente: {
      componente: "",
      concentracion: "",
    },
    componentes: [],
    //ESPECIE INTERES DIAGNOSTICO
    especie_interes_diagnostico: {
      especie_id: "",
      especie_name: "",
    },
    especies_interes_diagnostico: [],
    //PRESENTACIONES
    presentacion: {
      //presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      presentacion_unidad_medida_name: "",
    },
    presentaciones: [],
    //ANALISIS GARANTIZADO
    analisis_garantizado: {
      analisis_id: "",
      analisis_name: "",
      porcentaje: "",
    },
    analisis: [],
    //INGREDIENTES
    ingrediente: {
      ingrediente_id: "",
      ingrediente_name: "",
    },
    ingredientes: [],
    fabricantes: [], //establecimientos a los que pertenezco que tengan como actividad fabricante
    representantes_legales: [], //listado de los representantes de los establecimientos a los que pertenezco
    regentes: [], //listado de los regentes de los establecimientos a los que pertenezco
    titulares: [], //listado de los establecimientos titulares
    tipo: "medicamento_veterinario",
    options_ingredientes_activos: [],
    options_ingredientes_activos_prod: [],
    options_ingredientes_excipientes: [],
    options_ingredientes_excipientes_prod: [],
    options_unidad_medida: Api.loadCatalogue("cat_unidad_medida"),
    options_especies: [],
    options_especies_aux: Api.loadCatalogue("cat_especie"),
    options_categoria: [],
    options_empaque: [],
    options_empaque_tipo_1: [],
    options_empaque_tipo_2: [],
    options_empaque_tipo_3: [],
    options_forma_farmaceutica: [],
    options_forma_farmaceutica_tipo_1: [],
    options_forma_farmaceutica_tipo_2: [],
    options_forma_farmaceutica_tipo_3: [],
    options_forma_farmaceutica_tipo_5: [],
    options_especies_producto: Api.loadCatalogue("cat_especie_producto"),
    options_medida_tiempo: Api.loadCatalogue("cat_medida_tiempo"),
    //options_forma_farmaceutica: Api.loadCatalogue("cat_forma_farmaceutica"),
    options_paises: Api.loadCatalogue("countries"),
    options_composicion_biologica: Api.loadCatalogue(
      "cat_composicion_biologica"
    ),
    options_composicion_quimica: Api.loadCatalogue("cat_composicion_quimica"),
    options_clasificacion: Api.loadCatalogue("cat_clasificacion"),
    options_analisis: Api.loadCatalogue("cat_analisis"),
    options_ingredientes: [],
    control_ingredientes: [],
  };

  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    this.state = this.initialState;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpcionesRadio = this.handleOpcionesRadio.bind(this);

    this.handlePrincipioActivo = this.handlePrincipioActivo.bind(this);
    this.addPrincipioActivo = this.addPrincipioActivo.bind(this);
    this.removePrincipioActivo = this.removePrincipioActivo.bind(this);

    this.handleExcipiente = this.handleExcipiente.bind(this);
    this.addExcipiente = this.addExcipiente.bind(this);
    this.removeExcipiente = this.removeExcipiente.bind(this);

    this.handleDosisEspecie = this.handleDosisEspecie.bind(this);
    this.addDosisEspecie = this.addDosisEspecie.bind(this);
    this.removeDosisEspecie = this.removeDosisEspecie.bind(this);

    this.handleEmpaque = this.handleEmpaque.bind(this);
    this.addEmpaque = this.addEmpaque.bind(this);
    this.removeEmpaque = this.removeEmpaque.bind(this);

    this.handleDescarte = this.handleDescarte.bind(this);
    this.addDescarte = this.addDescarte.bind(this);
    this.removeDescarte = this.removeDescarte.bind(this);

    this.handleComposicionBiologica =
      this.handleComposicionBiologica.bind(this);
    this.addComposicionBio = this.addComposicionBio.bind(this);
    this.removeComposicionBio = this.removeComposicionBio.bind(this);

    this.handleComposicionQuimica = this.handleComposicionQuimica.bind(this);
    this.addComposicionQuimica = this.addComposicionQuimica.bind(this);
    this.removeComposicionQuimica = this.removeComposicionQuimica.bind(this);

    this.handleComponente = this.handleComponente.bind(this);
    this.addComponente = this.addComponente.bind(this);
    this.removeComponente = this.removeComponente.bind(this);

    this.handleEspecieInteres = this.handleEspecieInteres.bind(this);
    this.addEspecieInteres = this.addEspecieInteres.bind(this);
    this.removeEspecieInteres = this.removeEspecieInteres.bind(this);

    this.handleModoEmpleo = this.handleModoEmpleo.bind(this);
    this.addModoEmpleo = this.addModoEmpleo.bind(this);
    this.removeModoEmpleo = this.removeModoEmpleo.bind(this);

    this.handlePresentaciones = this.handlePresentaciones.bind(this);
    this.addPresentaciones = this.addPresentaciones.bind(this);
    this.removePresentaciones = this.removePresentaciones.bind(this);

    this.handleAnalisis = this.handleAnalisis.bind(this);
    this.addAnalisis = this.addAnalisis.bind(this);
    this.removeAnalisis = this.removeAnalisis.bind(this);

    this.handleIngrediente = this.handleIngrediente.bind(this);
    this.addIngrediente = this.addIngrediente.bind(this);
    this.removeIngrediente = this.removeIngrediente.bind(this);

    this.handleReset = this.handleReset.bind(this);
    this.handleCaducidad = this.handleCaducidad.bind(this);

    this.verifyIngredient = this.verifyIngredient.bind(this);
    this.getIngredient = this.getIngredient.bind(this);
  }

  componentDidMount() {
    Api.loading(1);
    let tipo_producto_id = this.props.match.params["tipo_producto_id"];
    // if (tipo_producto_id === "3") {
    //   this.setState({ options_especies: this.state.options_especies });
    // }

    Api.fetch("app/getInfoAltaProducto?id=" + this.state.id).then((data) => {
      if (data) {
        this.setState({ 
          fabricante: data.fabricante.razon_social,
          establecimiento_id: data.fabricante.id,
          titulares: data.titulares, 
          titular_id: data.titulares[0].id,
          fabricantes: data.fabricantes,
          regentes: data.regentes,
          representantes_legales: data.representantes,
          options_especies_aux: data.especies,
          options_categoria: data.categorias,
          options_categoria_aux: data.categorias
         });
      }
    }).catch((error) => {
      error.json().then((message) => {
        Swal.fire({
          title: "Ocurrió un error al procesar la actividad",
          icon: "error",
          text: message.message
        });
      }); //catching errors to show notification
    });

    let tipos_producto = 0;
    if (tipo_producto_id === "1" || tipo_producto_id === "2") {
      tipos_producto = 12;
      Api.fetch("cat/getIngredienteTipoMedicamento").then((data) => {
        if (data) {
          let activos = data.activos.filter(
            (obj) => obj.tipo_control_id !== "1"
          );
          let excipientes = data.excipiente.filter(
            (obj) => obj.tipo_control_id !== "1"
          );

          this.setState({
            options_ingredientes_activos: activos,
            options_ingredientes_excipientes: excipientes,
          });
        }
      });
    }

    if (tipo_producto_id === "3" || tipo_producto_id === "4") {
      tipos_producto = 34;
      Api.fetch("cat/getIngredienteTipoAlimento").then((data) => {
        if (data) {
          let ingredientesActivos = data.alimento.filter(
            (obj) => obj.tipo_control_id !== "1"
          );
          this.setState({
            options_ingredientes: ingredientesActivos,
            options_ingredientes_aux: ingredientesActivos,
          });
        }
      });
    }

    let pais = tipo_producto_id === "1" || tipo_producto_id === "3" ? "1" : "";
    this.setState({
      pais_origen_id: pais,
    }) 

    Api.fetch("cat/getAllIngredients").then((data) => {
      if (data) {
        this.setState({
          cat_ingredientes_ric: data.ingredientes,
        });
      }
    });

    Api.fetch("app/getFormaFarmaceuticaEmpaque?tipos="+tipos_producto).then((data) => {
      if (data) {
        if (tipo_producto_id === "1" || tipo_producto_id === "2") {
          this.setState({
            options_forma_farmaceutica: data.farmaceutica.tipo_1,
            options_forma_farmaceutica_tipo_1: data.farmaceutica.tipo_1,
            options_forma_farmaceutica_tipo_2: data.farmaceutica.tipo_2,
            options_forma_farmaceutica_tipo_3: data.farmaceutica.tipo_3,
            options_empaque: data.empaque.tipo_1,
            options_empaque_tipo_1: data.empaque.tipo_1,
            options_empaque_tipo_2: data.empaque.tipo_2,
            options_empaque_tipo_3: data.empaque.tipo_3,
          });
        } else if (tipo_producto_id === "3" || tipo_producto_id === "4") {
          this.setState({
            options_forma_farmaceutica: data.farmaceutica.tipo_5,
            options_empaque: data.empaque.empaque_tipo_alimento,
          });
        }
      }
    }).catch((error) => {
      error.json().then((message) => {
        Swal.fire({
          title: "Ocurrió un error al procesar la actividad",
          icon: "error",
          text: message.message
        });
      }); //catching errors to show notification
    });

    /* Validar principio activo y excipiente */
    Api.fetch("app/getControlIngredientes").then((r) => {
      Api.loading(0);
      this.setState({ control_ingredientes: r });

      let liveWatch = setInterval(
        // Tip timer
        (x) => {
          if (
            window.location.toString().split("/")[4] !== "inscripcion-producto"
          ) {
            clearInterval(liveWatch);
          }

          let opt = document.querySelectorAll("#categoria_id > option");
          for (let i = 0; i < opt.length; i++) {
            opt[i].removeAttribute("disabled");
          }

          if (document.querySelector("#categoria_id") !== null) {
            document.querySelector("#categoria_id").removeAttribute("disabled");
          }

          for (let pa in this.state.principios_activos) {
            this.state.control_ingredientes.find((e, indexe) => {
              let dosis = [...this.state.dosis];
              dosis.find((o, indexo) => {
                if (o) {
                  if (
                    e.especie === o.especie_name &&
                    e.categoria === o.categoria_name
                  ) {
                    if (e.estado === "Prohibido") {
                      dosis.splice(indexo, 1);
                      this.setState({ dosis: dosis });
                    }
                  }
                }
              });

              if (
                e.nombre ===
                this.state.principios_activos[pa].principio_activo_name
              ) {
                opt = document.querySelector(
                  "#categoria_id > option[data-categoria='" + e.categoria + "']"
                );
                if (opt) {
                  opt.setAttribute("disabled", 1);
                }
              }
            });
          }

          for (let ex in this.state.excipientes) {
            this.state.control_ingredientes.find((e, indexe) => {
              let dosis = [...this.state.dosis];
              dosis.find((o, indexo) => {
                if (o) {
                  if (
                    e.especie === o.especie_name &&
                    e.categoria === o.categoria_name
                  ) {
                    if (e.estado === "Prohibido") {
                      dosis.splice(indexo, 1);
                      this.setState({ dosis: dosis });
                    }
                  }
                }
              });

              if (
                e.nombre === this.state.excipientes[ex].principio_activo_name
              ) {
                opt = document.querySelector(
                  "#categoria_id > option[data-categoria='" + e.categoria + "']"
                );
                if (opt) {
                  opt.setAttribute("disabled", 1);
                }
              }
            });
          }
        },
        500
      );
    });
    //FIN VALIDAR PROHIBIDOS Y CONTROLADOS
  }

  handleReset = (e) => {
    window.location.href = "/productos/listado";
  };

  handleOpcionesRadio(e) {
    //dependiendo de el valor del tipo cambian ciertas listas y el valor de de tipo_producto_veterinario
    let opt_empaque = [];
    let opt_forma_farmaceutica = [];
    let tpv;
    let especies_restringidas = this.state.especies_restringidas;
    let categorias = this.state.options_categoria_aux;
    let options_especies = this.initialState.options_especies;

    opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_5;
    switch (e.target.value) {
      case "medicamento_veterinario":
        opt_empaque = this.state.options_empaque_tipo_1;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_1;
        tpv = "1";
        break;
      case "biologico":
        opt_empaque = this.state.options_empaque_tipo_2;
        options_especies = this.state.options_especies_aux;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_2;
        tpv = "2";
        break;
      case "producto_afin":
        opt_empaque = this.state.options_empaque_tipo_3;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_3;
        tpv = "3";
        break;
      case "reactivos_diagnosticos":
        options_especies = this.state.options_especies_aux;
        tpv = "4";
        break;
      default:
    }

    especies_restringidas.principio_activo = [];
    especies_restringidas.excipiente = [];

    this.setState({
      tipo: e.target.value,
      tipo_producto_veterinario_id: tpv,
      options_empaque: opt_empaque,
      options_forma_farmaceutica: opt_forma_farmaceutica,

      categorias_restringidas: [],
      categorias_restringidas_listadas: [],
      especies_restringidas: especies_restringidas,
      ingredientes_listados_restringidos: [],

      especies_restringidas_aux: especies_restringidas,
      options_categoria: categorias,
      options_especies: options_especies,

      excipiente: this.initialState.excipiente,
      principio_activo: this.initialState.principio_activo,
      excipientes: this.initialState.excipientes,
      principios_activos: this.initialState.principios_activos,
      dosis: this.initialState.dosis,
      dosis_especie: this.initialState.dosis_especie,

      composicion_biologica: this.initialState.composicion_biologica,
      composiciones_biologicas: this.initialState.composiciones_biologicas,
      composicion_quimica: this.initialState.composicion_quimica,
      composiciones_quimicas: this.initialState.composiciones_quimicas,
    });
  }

  getIngredient(id, tipo = null) {
    Api.fetch("app/getIngredient?id=" + id).then((data) => {
      if (tipo) {
        let ingLisRes = this.state.ingredientes_listados_restringidos,
          options_especies = this.state.options_especies_aux,
          options_categorias = this.state.options_categoria_aux,
          options_especies_sin_cat = this.state.options_especies_aux,
          especies_restringidas = this.state.especies_restringidas;

        // quitamos el ingrediente a remover de la lista de ingredientes registrados
        ingLisRes = ingLisRes.filter((obj) => obj !== data.id.toString());

        // obtenemos la info completa de las ingredientes listadas restantes
        ingLisRes = this.state.cat_ingredientes_ric.filter((obj) =>
          ingLisRes.includes(obj.id.toString())
        );

        let ingredientes_listados_restringidos = ingLisRes;
        ingredientes_listados_restringidos =
          ingredientes_listados_restringidos.map((obj) => obj.id.toString());

        // obtenemos la info de especies de esos ingredientes
        ingLisRes = ingLisRes.map((obj) => obj.rirec);

        // hacemos un merge para tener un array con todas las especies de cada ingrediente
        let especiesListadas = [];
        let categoriasListadas = [];
        ingLisRes.forEach((obj) => {
          obj.forEach((o) => {
            especiesListadas.push(o);
            categoriasListadas.push(o);
          });
        });

        if (tipo === 1) {
          especies_restringidas.principio_activo = especiesListadas;
        } else if (tipo === 2) {
          especies_restringidas.excipiente = especiesListadas;
        }

        // mapeamos un arreglo con el id de las especies
        especiesListadas = especiesListadas.map((obj) => obj.especie_id);
        categoriasListadas = categoriasListadas.map((obj) => obj.categoria_id);

        let totalEspeciesRes = especiesListadas.length;

        // obtenemos las especies sin categoria del catalogo de especies
        options_especies_sin_cat = options_especies_sin_cat.filter(
          (obj) => obj.categorias.length === 0 && obj.id !== 1
        );

        // mapeamos el id de las especies
        options_especies_sin_cat = options_especies_sin_cat.map((obj) =>
          obj.id.toString()
        );

        // filtramos que especies listadas pertenecen al grupo de especies sin categorias
        especiesListadas = especiesListadas.filter((obj) =>
          options_especies_sin_cat.includes(obj)
        );

        // filtramos las especies
        options_especies = options_especies.filter(
          (obj) => !especiesListadas.includes(obj.id.toString())
        );

        options_categorias = options_categorias.filter(
          (obj) => !categoriasListadas.includes(obj.id.toString())
        );

        if (totalEspeciesRes > 0) {
          options_especies = options_especies.filter(
            (obj) => obj.id.toString() !== "1"
          );
        }

        if (
          this.state.excipientes.length === 0 &&
          this.state.principios_activos.length === 0
        ) {
          options_especies = this.initialState.options_especies;
        }

        // actualizamos estados
        this.setState({
          options_categoria: options_categorias,
          especies_restringidas: especies_restringidas,
          options_especies: options_especies,
          ingredientes_listados_restringidos:
            ingredientes_listados_restringidos,
          excipiente: this.initialState.excipiente,
          principio_activo: this.initialState.principio_activo,
        });
      }
    });
  }

  // NOTA IMPORTANTE: esta fn es igual que la de arriba pero para el furmulario tipo 3, se deberia optimizar uniendo las 2 mas adelante pero por falta de tiempo del proyecto lo hice asi de momento para sacarlo rápido
  getIngredientInfo(id, tipo = null) {
    Api.fetch("app/getIngredient?id=" + id).then((data) => {
      let ingLisRes = this.state.ingredientes_listados_restringidos,
        options_especies = this.state.options_especies_aux,
        options_categorias = this.state.options_categoria_aux,
        options_especies_sin_cat = this.state.options_especies_aux,
        especies_restringido_alimento_animal =
          this.state.especies_restringido_alimento_animal;

      // quitamos el ingrediente a remover de la lista de ingredientes registrados
      ingLisRes = ingLisRes.filter((obj) => obj !== data.id.toString());

      // obtenemos la info completa de las ingredientes listadas restantes
      ingLisRes = this.state.cat_ingredientes_ric.filter((obj) =>
        ingLisRes.includes(obj.id.toString())
      );

      let ingredientes_listados_restringidos = ingLisRes;
      ingredientes_listados_restringidos =
        ingredientes_listados_restringidos.map((obj) => obj.id.toString());

      // obtenemos la info de especies de esos ingredientes
      ingLisRes = ingLisRes.map((obj) => obj.rirec);

      // hacemos un merge para tener un array con todas las especies de cada ingrediente
      let especiesListadas = [];
      let categoriasListadas = [];
      ingLisRes.forEach((obj) => {
        obj.forEach((o) => {
          especiesListadas.push(o);
          categoriasListadas.push(o);
        });
      });

      especies_restringido_alimento_animal = especiesListadas;

      // mapeamos un arreglo con el id de las especies
      especiesListadas = especiesListadas.map((obj) => obj.especie_id);
      categoriasListadas = categoriasListadas.map((obj) => obj.categoria_id);

      let totalEspeciesRes = especiesListadas.length;

      // obtenemos las especies sin categoria del catalogo de especies
      options_especies_sin_cat = options_especies_sin_cat.filter(
        (obj) => obj.categorias.length === 0 && obj.id !== 1
      );

      // mapeamos el id de las especies
      options_especies_sin_cat = options_especies_sin_cat.map((obj) =>
        obj.id.toString()
      );

      // filtramos que especies listadas pertenecen al grupo de especies sin categorias
      especiesListadas = especiesListadas.filter((obj) =>
        options_especies_sin_cat.includes(obj)
      );

      // filtramos las especies
      options_especies = options_especies.filter(
        (obj) => !especiesListadas.includes(obj.id.toString())
      );

      options_categorias = options_categorias.filter(
        (obj) => !categoriasListadas.includes(obj.id.toString())
      );

      if (totalEspeciesRes > 0) {
        options_especies = options_especies.filter(
          (obj) => obj.id.toString() !== "1"
        );
      }

      if (this.state.ingredientes.length === 0) {
        options_especies = this.initialState.options_especies;
      }

      // actualizamos estados
      this.setState({
        options_categoria: options_categorias,
        options_especies: options_especies,
        ingredientes_listados_restringidos: ingredientes_listados_restringidos,
        especies_restringido_alimento_animal:
          especies_restringido_alimento_animal,
      });
    });
  }

  verifyIngredient(id, tipoSelect = null) {
    // verificamos si el ingrediente es restringido y si es así buscar las especies
    Api.fetch("app/verifyIngredient?id=" + id).then((data) => {
      let especies_restringidas = this.state.especies_restringidas,
        categorias_restringidas = [],
        options_especies = this.state.options_especies_aux,
        options_categorias = this.state.options_categoria_aux,
        categorias = [],
        especies_restringidas_merge = [],
        categorias_restringidas_listadas = [],
        especies_restringido_alimento_animal =
          this.state.especies_restringido_alimento_animal,
        ingredientes_listados_restringidos =
          this.state.ingredientes_listados_restringidos,
        cat_ingredientes_ric = this.state.cat_ingredientes_ric,
        especies_restringidas_aux = this.state.especies_restringidas;

      if (
        this.state.tipo_producto_id === "1" ||
        this.state.tipo_producto_id === "2"
      ) {
        // inicialicamos el arreglo dependiendo si es principio activo (1) o excipiente (2)
        tipoSelect === "1"
          ? (especies_restringidas.principio_activo = [])
          : (especies_restringidas.excipiente = []);
      }

      if (
        this.state.tipo_producto_id === "3" ||
        this.state.tipo_producto_id === "4"
      ) {
        especies_restringido_alimento_animal = [];
      }

      if (data) {
        let ingredientes_res_info = [];
        cat_ingredientes_ric.forEach((obj) => {
          if (ingredientes_listados_restringidos.includes(obj.id.toString())) {
            ingredientes_res_info.push(obj);
          }
        });

        let categorias_res_info = [],
          especies_res_info = [];

        if (ingredientes_res_info.length > 0) {
          ingredientes_res_info.forEach((obj) => {
            obj.rirec.forEach((o) => {
              if (o.especie_id && !o.categoria_id) {
                especies_res_info.push(o.especie_id);
              }

              if (o.categoria_id) {
                categorias_res_info.push(o.categoria_id);
              }
            });
          });
        }

        // dependiendo del tipo de select hacemos push en el array correspondiente
        if (
          this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2"
        ) {
          data.forEach((d) => {
            tipoSelect === "1"
              ? especies_restringidas.principio_activo.push(d)
              : especies_restringidas.excipiente.push(d);
          });

          // si el length de los dos tipos son ceros quiere decir que no hay ingredientes restringidos y se deja el cat especies normal
          if (
            especies_restringidas.excipiente.length === 0 &&
            especies_restringidas.principio_activo.length === 0
          ) {
            options_especies = this.state.options_especies_aux;
            categorias = this.state.options_categoria_aux;
          } else {
            // si hay por lo menos 1 quitamos la opción de "todas las especies" del catalogo de especies
            options_especies = options_especies.filter(
              (obj) => obj.id.toString() !== "1"
            );

            // unimos los dos tipos de arreglos
            especies_restringidas_merge = [
              ...especies_restringidas.principio_activo,
              ...especies_restringidas.excipiente,
            ];

            // filtro del catalogo las especies que no tienen categorias a excepcion de la opcion de "todas las especies"
            let especiesSinCat = options_especies.filter(
              (obj) => obj.categorias.length === 0 && obj.id.toString() !== "1"
            );

            // hago map para tener un arreglo con solo los id de esas especies sin catalogo
            especiesSinCat = especiesSinCat.map((obj) => obj.id.toString());

            // hago un map para tener un arreglo del merge de especies restringidas paras tener solo el ids
            let especiesProhibidas = especies_restringidas_merge.map(
              (obj) => obj.especie_id
            );

            // filtro del merge si hay ids que perteneces a una especie sin categoria
            let filtroEspNoCat = especiesProhibidas.filter((obj) =>
              especiesSinCat.includes(obj)
            );

            // hacemos filtros de options especies que estes restringidos y no tengan categoria
            if (filtroEspNoCat.length > 0) {
              options_especies = options_especies.filter(
                (obj) => !filtroEspNoCat.includes(obj.id.toString())
              );
            }

            // guardamos las categorias restringiidas que esten ligadas a la especie para filtrar options_categorias
            especies_restringidas_merge.forEach((obj) => {
              categorias_restringidas.push(obj.categoria_id);
            });

            // filtramos options categorias por las categorias restringidas
            options_categorias.forEach((obj) => {
              if (
                !categorias_restringidas.includes(obj.id.toString()) &&
                !categorias_restringidas_listadas.includes(obj.id.toString())
              ) {
                categorias.push(obj);
              } else {
                categorias_restringidas_listadas.push(obj.id.toString());
              }
            });
          }
        } else if (
          this.state.tipo_producto_id === "3" ||
          this.state.tipo_producto_id === "4"
        ) {
          data.forEach((d) => especies_restringido_alimento_animal.push(d));

          if (especies_restringido_alimento_animal.length === 0) {
            options_especies = this.state.options_especies_aux;
            categorias = this.state.options_categoria_aux;
          } else {
            options_especies = options_especies.filter(
              (obj) => obj.id.toString() !== "1"
            );

            // guardamos las categorias restringiidas que esten ligadas a la especie para filtrar options_categorias
            especies_restringido_alimento_animal.forEach((obj) => {
              categorias_restringidas.push(obj.categoria_id);
            });

            //---------------
            // filtro del catalogo las especies que no tienen categorias a excepcion de la opcion de "todas las especies"
            let especiesSinCat = options_especies.filter(
              (obj) => obj.categorias.length === 0 && obj.id.toString() !== "1"
            );

            // hago map para tener un arreglo con solo los id de esas especies sin catalogo
            especiesSinCat = especiesSinCat.map((obj) => obj.id.toString());

            // hago un map para tener un arreglo del merge de especies restringidas paras tener solo el ids
            let especiesProhibidas = especies_restringido_alimento_animal.map(
              (obj) => obj.especie_id
            );

            // filtro del merge si hay ids que perteneces a una especie sin categoria
            let filtroEspNoCat = especiesProhibidas.filter((obj) =>
              especiesSinCat.includes(obj)
            );

            // hacemos filtros de options especies que estes restringidos y no tengan categoria
            if (filtroEspNoCat.length > 0) {
              options_especies = options_especies.filter(
                (obj) => !filtroEspNoCat.includes(obj.id.toString())
              );
            }

            // guardamos las categorias restringiidas que esten ligadas a la especie para filtrar options_categorias
            especies_restringido_alimento_animal.forEach((obj) => {
              categorias_restringidas.push(obj.categoria_id);
            });

            //---------------

            // filtramos options categorias por las categorias restringidas
            options_categorias.forEach((obj) => {
              if (
                !categorias_restringidas.includes(obj.id.toString()) &&
                !categorias_restringidas_listadas.includes(obj.id.toString())
              ) {
                categorias.push(obj);
              } else {
                categorias_restringidas_listadas.push(obj.id.toString());
              }
            });
          }
        }

        if (especies_res_info.length > 0) {
          // falta filtrar por especies sin cat
          options_especies = options_especies.filter(
            (obj) => !especies_res_info.includes(obj.id.toString())
          );
        }

        if (ingredientes_res_info.length > 0) {
          // si hay por lo menos 1 quitamos la opción de "todas las especies" del catalogo de especies
          options_especies = options_especies.filter(
            (obj) => obj.id.toString() !== "1"
          );
        }

        if (categorias_res_info.length > 0) {
          categorias = categorias.filter(
            (obj) => !categorias_res_info.includes(obj.id.toString())
          );
        }

        this.setState({
          especies_restringidas: especies_restringidas,
          options_especies: options_especies,
          options_categoria: categorias,
          categorias_restringidas_listadas: categorias_restringidas_listadas,
          especies_restringidas_aux: especies_restringidas_aux,
          especies_restringido_alimento_animal:
            especies_restringido_alimento_animal,
        });
      }
    });
  }

  /* PRINCIPIO ACTIVO */

  handlePrincipioActivo(e) {
    let tipo_control = e.target[e.target.selectedIndex];
    if (e.target.name === "principio_activo_id") {
      // verificamos el tipo de control del principio activo
      if (
        (this.state.tipo === "medicamento_veterinario" ||
          this.state.tipo === "producto_afin") &&
        (this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2")
      ) {
        this.verifyIngredient(e.target.value, "1"); // 1 = a principio activo
      }
    }

    // let swalType = {
    //   Normal: "",
    //   Prohibido: "error",
    //   Controlado: "warning",
    // };

    // let esp = "";
    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        // this.state.control_ingredientes.find((o) => {
        //   if (o.nombre === tipo_control.innerText) {
        //     if (!o.categoria) {
        //       e.target.value = "";
        //       esp += "<li><b>" + o.especie + "</b></li>";
        //       return;
        //     } else {
        //       esp += "<li><b>" + o.especie + "</b> " + o.categoria + "</li>";
        //     }
        //   }
        // });

        Swal.fire({
          icon: "warning",
          title: "¡Atención!",
          text: `Principio activo ${tipo_control.innerText.toUpperCase()} está ${tipo_control.dataset.tipo.toLowerCase()}`,
        });
      }
    }

    let rep = { ...this.state.principio_activo }; //hacemos una copia del objeto

    if (e.target.name === "principio_activo_id" && e.target.value !== "") {
      let principio_activo_name = this.state.options_ingredientes_activos.find(
        (d) => d.id === e.target.value
      );
      if (principio_activo_name) {
        rep["principio_activo_name"] = principio_activo_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    this.setState({
      principio_activo: rep,
    });
  }

  addPrincipioActivo(e) {
    let rep = { ...this.state.principio_activo };
    let pa = [...this.state.principios_activos];
    let dosis = this.state.dosis;
    let categorias_restringidas_listadas =
        this.state.categorias_restringidas_listadas,
      especies_restringidas = this.state.especies_restringidas,
      ingredientes_listados_restringidos =
        this.state.ingredientes_listados_restringidos;

    if (
      rep.principio_activo_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in this.state.principios_activos) {
        if (pa[re].principio_activo_id === rep.principio_activo_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);

      especies_restringidas = especies_restringidas.principio_activo.map(
        (obj) => obj.ingrediente_id
      );

      if (especies_restringidas.includes(rep.principio_activo_id)) {
        ingredientes_listados_restringidos.push(rep.principio_activo_id);
      }

      let especieSinCat =
        this.state.especies_restringidas.principio_activo.filter(
          (obj) => obj.categoria_id === null
        );

      if (especieSinCat) {
        especieSinCat = especieSinCat.map((obj) => obj.especie_id);
      }

      if (
        this.state.tipo === "medicamento_veterinario" ||
        this.state.tipo === "producto_afin"
      ) {
        if (
          this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2"
        ) {
          if (this.state.especies_restringidas.principio_activo.length > 0) {
            dosis = dosis.filter(
              (obj) =>
                !categorias_restringidas_listadas.includes(obj.categoria_id) &&
                !especieSinCat.includes(obj.especie_id) &&
                obj.especie_id !== "1"
            );
          }

          // else {
          //   dosis = dosis.filter(
          //     (obj) =>
          //       !categorias_restringidas_listadas.includes(obj.categoria_id)
          //   );
          // }
        }
      }

      this.setState({
        principios_activos: pa,
        principio_activo: this.initialState.principio_activo,
        // excipiente: this.initialState.excipiente,
        principio_activo_temp: true,
        dosis: dosis,
        ingredientes_listados_restringidos: ingredientes_listados_restringidos,
      });
    }
  }

  removePrincipioActivo(e) {
    let principio_activos = [...this.state.principios_activos];

    if (
      (this.state.tipo === "medicamento_veterinario" ||
        this.state.tipo === "producto_afin") &&
      (this.state.tipo_producto_id === "1" ||
        this.state.tipo_producto_id === "2")
    ) {
      this.getIngredient(principio_activos[e.target.id].principio_activo_id, 1);
    }
    principio_activos.splice(e.target.id, 1);
    this.setState({ principios_activos: principio_activos });

    if (
      this.state.tipo === "medicamento_veterinario" ||
      this.state.tipo === "producto_afin"
    ) {
      if (
        this.state.tipo_producto_id === "1" ||
        this.state.tipo_producto_id === "2"
      ) {
        let options_especies = this.initialState.options_especies;

        if (
          principio_activos.length === 0 &&
          this.state.excipientes.length === 0
        ) {
          this.setState({
            options_especies: options_especies,
            dosis: this.initialState.dosis,
            options_categoria: this.initialState.options_categoria,
            modos_empleo: this.initialState.modos_empleo,
            dosis_especie: this.initialState.dosis_especie,
            principio_activo: this.initialState.principio_activo,
            excipiente: this.initialState.excipiente,
          });
        }
      }
    }
  }

  /* EXCIPIENTE */

  handleExcipiente(e) {
    let tipo_control = e.target[e.target.selectedIndex];

    if (e.target.name === "excipiente_id") {
      if (
        (this.state.tipo === "medicamento_veterinario" ||
          this.state.tipo === "producto_afin") &&
        (this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2")
      ) {
        // verificamos el tipo de control del principio activo
        this.verifyIngredient(e.target.value, "3"); //excipiente
      }
    }
    // let swalType = {
    //   Normal: "",
    //   Prohibido: "error",
    //   Controlado: "warning",
    // };

    // let esp = "";
    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        // this.state.control_ingredientes.find((o) => {
        //   if (o.nombre === tipo_control.innerText) {
        //     if (!o.categoria) {
        //       //e.target.value="";  //Se limpia para no dejar pasar esta especie
        //       esp += "<li><b>" + o.especie + "</b></li>";
        //       return;
        //     } else {
        //       esp += "<li><b>" + o.especie + "</b> " + o.categoria + "</li>";
        //     }
        //   }
        // });

        Swal.fire({
          icon: "warning",
          title: "¡Atención!",
          text: `Excipiente ${tipo_control.innerText.toUpperCase()} está ${tipo_control.dataset.tipo.toLowerCase()}`,
        });
      }
    }

    let rep = { ...this.state.excipiente }; //hacemos una copia del objeto

    if (e.target.name === "excipiente_id" && e.target.value !== "") {
      let excipiente_name = this.state.options_ingredientes_excipientes.find(
        (d) => d.id.toString() === e.target.value
      );
      if (excipiente_name) {
        rep["excipiente_name"] = excipiente_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id.toString() === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    this.setState({ excipiente: rep });
  }

  addExcipiente(e) {
    let rep = { ...this.state.excipiente };
    let pa = [...this.state.excipientes];
    let categorias_restringidas_listadas =
        this.state.categorias_restringidas_listadas,
      dosis = this.state.dosis,
      ingredientes_listados_restringidos =
        this.state.ingredientes_listados_restringidos,
      especies_restringidas = this.state.especies_restringidas;

    if (
      rep.excipiente_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in this.state.excipientes) {
        if (pa[re].excipiente_id === rep.excipiente_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);

      especies_restringidas = especies_restringidas.excipiente.map(
        (obj) => obj.ingrediente_id
      );

      if (especies_restringidas.includes(rep.excipiente_id)) {
        ingredientes_listados_restringidos.push(rep.excipiente_id);
      }

      let especieSinCat = this.state.especies_restringidas.excipiente.filter(
        (obj) => obj.categoria_id === null
      );

      if (especieSinCat) {
        especieSinCat = especieSinCat.map((obj) => obj.especie_id);
      }

      if (
        this.state.tipo === "medicamento_veterinario" ||
        this.state.tipo === "producto_afin"
      ) {
        if (
          this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2"
        ) {
          if (this.state.especies_restringidas.excipiente.length > 0) {
            dosis = dosis.filter(
              (obj) =>
                !categorias_restringidas_listadas.includes(obj.categoria_id) &&
                !especieSinCat.includes(obj.especie_id) &&
                obj.especie_id !== "1"
            );
          }
          //  else {
          //   dosis = dosis.filter(
          //     (obj) =>
          //       !categorias_restringidas_listadas.includes(obj.categoria_id)
          //   );
          // }
        }
      }

      this.setState({
        excipientes: pa,
        excipiente: this.initialState.excipiente,
        // principio_activo: this.initialState.principio_activo,
        excipiente_temp: true,
        dosis: dosis,
        ingredientes_listados_restringidos: ingredientes_listados_restringidos,
      });
    }
  }

  removeExcipiente(e) {
    let excipientes = [...this.state.excipientes];
    if (
      (this.state.tipo === "medicamento_veterinario" ||
        this.state.tipo === "producto_afin") &&
      (this.state.tipo_producto_id === "1" ||
        this.state.tipo_producto_id === "2")
    ) {
      this.getIngredient(excipientes[e.target.id].excipiente_id, 2);
    }
    excipientes.splice(e.target.id, 1);
    this.setState({ excipientes: excipientes });

    let options_especies = this.initialState.options_especies;

    if (
      this.state.tipo === "medicamento_veterinario" ||
      this.state.tipo === "producto_afin"
    ) {
      if (
        this.state.tipo_producto_id === "1" ||
        this.state.tipo_producto_id === "2"
      ) {
        if (
          excipientes.length === 0 &&
          this.state.principios_activos.length === 0
        ) {
          this.setState({
            options_especies: options_especies,
            dosis: this.initialState.dosis,
            modos_empleo: this.initialState.modos_empleo,
            options_categoria: this.initialState.options_categoria,
            dosis_especie: this.initialState.dosis_especie,
            principio_activo: this.initialState.principio_activo,
            excipiente: this.initialState.excipiente,
          });
        }
      }
    }
  }

  /* DOSIS */

  handleDosisEspecie(e) {
    let rep = { ...this.state.dosis_especie };

    // // if (this.state.tipo_producto_id === "2") {
    if (e.target.name === "especie_id" && e.target.value !== "") {
      if (e.target.value === "1" && rep["categoria_name"]) {
        rep["categoria_name"] = "";
      }
      let especie_name = this.state.options_especies.find(
        (d) => d.id.toString() === e.target.value.toString()
      );
      rep[e.target.name] = e.target.value;
      if (especie_name) {
        rep["especie_name"] = especie_name.descripcion;
      }
      let categorias = this.state.options_categoria.find(
        (d) => d.especie_id.toString() === e.target.value.toString()
      );

      if (categorias !== undefined) {
        rep["tiene_categoria"] = true;
      } else {
        rep["tiene_categoria"] = false;
      }
    } else if (e.target.name === "categoria_id" && e.target.value !== "") {
      let categoria_name = this.state.options_categoria.find(
        (d) => d.id.toString() === e.target.value.toString()
      );
      rep[e.target.name] = e.target.value;
      if (categoria_name) {
        rep["categoria_name"] = categoria_name.descripcion;
      }
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }
    // }

    this.setState({ dosis_especie: rep });
  }

  addDosisEspecie(e) {
    let rep = { ...this.state.dosis_especie };
    let pa = [...this.state.dosis];
    if (
      (rep.dosis !== "" &&
        rep.especie_id !== "" &&
        rep.categoria_id !== "" &&
        rep.tiene_categoria === true) ||
      (rep.dosis !== "" &&
        rep.especie_id !== "" &&
        rep.tiene_categoria === false)
    ) {
      for (let re in this.state.dosis) {
        if ((pa[re].especie_id === rep.especie_id && pa[re].categoria_id === rep.categoria_id) 
          || (pa[re].especie_id === rep.especie_id && rep.tiene_categoria === false)) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie en su lista.",
          });
          return false;
        }
      }

      if (
        this.state.tipo === "medicamento_veterinario" &&
        (this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2")
      ) {
        if (
          this.state.principios_activos.length === 0 &&
          this.state.excipientes.length === 0
        ) {
          Swal.fire({
            icon: "warning",
            title: "¡Atención!",
            text: "Debe agrear un excipiente y/o principio activo",
          });
        } else {
          let todas = pa.find((obj) => obj.especie_id === "1");
          if (rep.especie_id === "1" || todas) {
            pa = [];
            pa.push(rep);
          } else {
            pa.push(rep);
          }

          this.setState({
            dosis: pa,
            dosis_especie: this.initialState.dosis_especie,
            principio_activo: this.initialState.principio_activo,
            excipiente: this.initialState.excipiente,
            principio_activo_temp: this.initialState.principio_activo_temp,
            excipiente_temp: this.initialState.excipiente_temp,
          });
        }
      } else {
        if (
          this.state.tipo_producto_id === "3" ||
          this.state.tipo_producto_id === "4"
        ) {
          let todas = pa.find((obj) => obj.especie_id === "1");
          if (rep.especie_id === "1" || todas) {
            pa = [];
            pa.push(rep);
          } else {
            pa.push(rep);
          }
        } else {
          pa.push(rep);
        }

        this.setState({
          dosis: pa,
          dosis_especie: this.initialState.dosis_especie,
          principio_activo: this.initialState.principio_activo,
          excipiente: this.initialState.excipiente,
          principio_activo_temp: this.initialState.principio_activo_temp,
          excipiente_temp: this.initialState.excipiente_temp,
        });
      }
    }
  }

  removeDosisEspecie(e) {
    let dosis = [...this.state.dosis];
    dosis.splice(e.target.id, 1);
    this.setState({ dosis: dosis });
  }

  /* EMPAQUE */

  handleEmpaque(e) {
    let rep = { ...this.state.empaque };
    if (e.target.name === "empaque_id" && e.target.value !== "") {
      let empaque_name = this.state.options_empaque.find(
        (d) => d.id === e.target.value
      );
      rep["empaque_name"] = empaque_name.descripcion;
    } else if (
      e.target.name === "presentacion_unidad_medida" &&
      e.target.value !== ""
    ) {
      let presentacion_unidad_medida = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["presentacion_unidad_medida_name"] =
        presentacion_unidad_medida.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ empaque: rep });
  }

  addEmpaque(e) {
    let rep = { ...this.state.empaque };

    let pa = [...this.state.empaques];
console.log(pa);
    if (
      rep.empaque_id !== "" &&
      rep.presentacion_cantidad !== "" &&
      rep.presentacion_unidad_medida !== ""
    ) {
      for (let re in this.state.empaques) {
        if (pa[re].empaque_id === rep.empaque_id &&
          pa[re].presentacion_cantidad === rep.presentacion_cantidad &&
          pa[re].presentacion_unidad_medida === rep.presentacion_unidad_medida ) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con ésta presentación en su lista.",
          });
          return false;
        } 
      }
      pa.push(rep);
      this.setState({ empaques: pa, empaque: this.initialState.empaque });
    }
  }

  removeEmpaque(e) {
    let empaques = [...this.state.empaques];
    empaques.splice(e.target.id, 1);
    this.setState({ empaques: empaques });
  }

  /* DESCARTE */

  handleDescarte(e) {
    let rep = { ...this.state.descarte };

    if (e.target.name === "medida_tiempo_id" && e.target.value !== "") {
      let medida_tiempo_name = this.state.options_medida_tiempo.find(
        (d) => d.id === e.target.value
      );
      rep["medida_tiempo_name"] = medida_tiempo_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else if (e.target.name === "especie_prod_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies_producto.find(
        (d) => d.id === e.target.value
      );
      rep["especie_prod_name"] = especie_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ descarte: rep });
  }

  addDescarte(e) {
    let rep = { ...this.state.descarte };
    let pa = [...this.state.descartes];

    if (
      rep.periodo !== "" &&
      rep.medida_tiempo_id &&
      rep.especie_prod_id !== ""
    ) {
      for (let re in pa) {
        if (pa[re].especie_prod_id === rep.especie_prod_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este producto en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({ descartes: pa, descarte: this.initialState.descarte });
    }
  }

  removeDescarte(e) {
    let descartes = [...this.state.descartes];
    descartes.splice(e.target.id, 1);
    this.setState({ descartes: descartes });
  }

  /* COMPOSICION BIOLOGICA */
  handleComposicionBiologica(e) {
    let rep = { ...this.state.composicion_biologica };
    if (e.target.name === "composicion_biologica_id" && e.target.value !== "") {
      let composicion_biologica_name =
        this.state.options_composicion_biologica.find(
          (d) => d.id === e.target.value
        );
      rep["composicion_biologica_name"] =
        composicion_biologica_name.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ composicion_biologica: rep });
  }

  addComposicionBio(e) {
    let rep = { ...this.state.composicion_biologica };
    let pa = [...this.state.composiciones_biologicas];

    if (
      rep.composicion_biologica_id !== "" &&
      rep.titulo_unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].composicion_biologica_id === rep.composicion_biologica_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta composición biológica en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({
        composiciones_biologicas: pa,
        composicion_biologica: this.initialState.composicion_biologica,
      });
    }
  }

  removeComposicionBio(e) {
    let composiciones_biologicas = [...this.state.composiciones_biologicas];
    composiciones_biologicas.splice(e.target.id, 1);
    this.setState({ composiciones_biologicas: composiciones_biologicas });
  }

  /* COMPOSICION QUIMICA*/

  handleComposicionQuimica(e) {
    let rep = { ...this.state.composicion_quimica };
    if (e.target.name === "composicion_quimica_id" && e.target.value !== "") {
      let composicion_quimica_name =
        this.state.options_composicion_quimica.find(
          (d) => d.id === e.target.value
        );
      rep["composicion_quimica_name"] = composicion_quimica_name.descripcion;
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value;
    this.setState({ composicion_quimica: rep });
  }

  addComposicionQuimica(e) {
    let rep = { ...this.state.composicion_quimica };
    let pa = [...this.state.composiciones_quimicas];

    if (
      rep.composicion_quimica_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].composicion_quimica_id === rep.composicion_quimica_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta composición química en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({
        composiciones_quimicas: pa,
        composicion_quimica: this.initialState.composicion_quimica,
      });
    }
  }

  removeComposicionQuimica(e) {
    let composiciones_quimicas = [...this.state.composiciones_quimicas];
    composiciones_quimicas.splice(e.target.id, 1);
    this.setState({ composiciones_quimicas: composiciones_quimicas });
  }

  /* COMPONENTE */

  handleComponente(e) {
    let rep = { ...this.state.componente };
    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ componente: rep });
  }

  addComponente(e) {
    let rep = { ...this.state.componente };
    let pa = [...this.state.componentes];

    if (rep.componente !== "" && rep.concentracion !== "") {
      pa.push(rep);
      this.setState({
        componentes: pa,
        componente: this.initialState.componente,
      });
    }
  }

  removeComponente(e) {
    let componentes = [...this.state.componentes];
    componentes.splice(e.target.id, 1);
    this.setState({ componentes: componentes });
  }

  /* ESPECIE DE INTERES */

  handleEspecieInteres(e) {
    let rep = { ...this.state.especie_interes_diagnostico };
    let especie_name = this.state.options_especies_aux.find(
      //(d) => d.id.toString() === e.target.value.toString()
      (d) =>  parseInt(d.id) === parseInt(e.target.value)
    );
    rep[e.target.name] = e.target.value;
    rep["especie_name"] = especie_name.descripcion;

    this.setState({ especie_interes_diagnostico: rep });
  }

  addEspecieInteres(e) {
    let rep = { ...this.state.especie_interes_diagnostico };
    let pa = [...this.state.especies_interes_diagnostico];

    if (rep.especie_id !== "") {
      for (let re in pa) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie de interés en su lista.",
          });
          return false;
        }
      }
      pa.push(rep);
      this.setState({
        especies_interes_diagnostico: pa,
        especie_interes_diagnostico:
          this.initialState.especie_interes_diagnostico,
      });
    }
  }

  removeEspecieInteres(e) {
    let especies_interes_diagnostico = [
      ...this.state.especies_interes_diagnostico,
    ];
    especies_interes_diagnostico.splice(e.target.id, 1);
    this.setState({
      especies_interes_diagnostico: especies_interes_diagnostico,
    });
  }

  /* MODO DE EMPLEO */

  handleModoEmpleo(e) {
    let rep = { ...this.state.modo_empleo };

    if (e.target.name === "especie_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies.find(
        (d) => d.id.toString() === e.target.value.toString()
      );
      rep[e.target.name] = e.target.value;
      rep["especie_name"] = especie_name.descripcion;
      let categorias = this.state.options_categoria.find(
        (d) => d.especie_id === e.target.value
      );

      if (categorias !== undefined) {
        rep["tiene_categoria"] = true;
      } else {
        rep["tiene_categoria"] = false;
      }
    } else if (e.target.name === "categoria_id" && e.target.value !== "") {
      let categoria_name = this.state.options_categoria.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      rep["categoria_name"] = categoria_name.descripcion;
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ modo_empleo: rep });
  }

  handleCaducidad(evt) {
    if (this.valPositiveNumber(evt.target.value)) {
      this.setState({ caducidad_producto: evt.target.value });
    }
  }

  valPositiveNumber(char) {
    let regex = /^([0]?|[1-9]+[0]*)$/;
    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  addModoEmpleo(e) {
    let rep = { ...this.state.modo_empleo };
    let pa = [...this.state.modos_empleo];

    if (
      (rep.modo_empleo !== "" &&
        rep.especie_id !== "" &&
        rep.categoria_id !== "" &&
        rep.tiene_categoria === true) ||
      (rep.modo_empleo !== "" &&
        rep.especie_id !== "" &&
        rep.tiene_categoria === false)
    ) {
      /*for (let re in this.state.modos_empleo) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie en su lista.",
          });
          return false;
        } */

      if (
        this.state.tipo === "producto_afin" &&
        (this.state.tipo_producto_id === "1" ||
          this.state.tipo_producto_id === "2")
      ) {
        if (
          this.state.principios_activos.length === 0 &&
          this.state.excipientes.length === 0
        ) {
          Swal.fire({
            icon: "warning",
            title: "¡Atención!",
            text: "Debe agrear un excipiente y/o principio activo",
          });
        } else {
          pa.push(rep);
          this.setState({
            modos_empleo: pa,
            modo_empleo: this.initialState.modo_empleo,
          });
        }
      } else {
        pa.push(rep);
        this.setState({
          modos_empleo: pa,
          modo_empleo: this.initialState.modo_empleo,
        });
      }
    }
  }

  removeModoEmpleo(e) {
    let modos_empleo = [...this.state.modos_empleo];
    modos_empleo.splice(e.target.id, 1);
    this.setState({ modos_empleo: modos_empleo });
  }

  /* PRESENTACIONES */

  handlePresentaciones(e) {
    let rep = { ...this.state.presentacion };
    if (
      e.target.name === "presentacion_unidad_medida" &&
      e.target.value !== ""
    ) {
      let presentacion_unidad_medida = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["presentacion_unidad_medida_name"] =
        presentacion_unidad_medida.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ presentacion: rep });
  }

  addPresentaciones(e) {
    let rep = { ...this.state.presentacion };
    let pa = this.state.presentaciones;

    if (
      rep.presentacion_cantidad !== "" &&
      rep.presentacion_unidad_medida !== ""
    ) {
      pa.push(rep);
      this.setState({
        presentaciones: pa,
        presentacion: this.initialState.presentacion,
      });
    }
  }

  removePresentaciones(e) {
    let presentaciones = [...this.state.presentaciones];
    presentaciones.splice(e.target.id, 1);
    this.setState({ presentaciones: presentaciones });
  }

  /* ANALISIS GARANTIZADO */

  handleAnalisis(e) {
    let rep = { ...this.state.analisis_garantizado };
    if (e.target.name === "analisis_id" && e.target.value !== "") {
      let analisis_name = this.state.options_analisis.find(
        (d) => d.id === e.target.value
      );
      rep["analisis_name"] = analisis_name.descripcion;
    }
    rep[e.target.name] = e.target.value;
    this.setState({ analisis_garantizado: rep });
  }

  addAnalisis(e) {
    let rep = { ...this.state.analisis_garantizado };
    let pa = [...this.state.analisis];

    if (rep.analisis_id !== "") {
      for (let re in pa) {
        if (pa[re].analisis_id === rep.analisis_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este análisis en su lista.",
          });
          return false;
        }
      }
      pa.push(rep);
      this.setState({
        analisis: pa,
        analisis_garantizado: this.initialState.analisis_garantizado,
      });
    }
  }

  removeAnalisis(e) {
    let analisis = [...this.state.analisis];
    analisis.splice(e.target.id, 1);
    this.setState({
      analisis: analisis,
    });
  }

  /* INGREDIENTES */

  handleIngrediente(e) {
    let tipo_control = e.target[e.target.selectedIndex];

    if (
      this.state.tipo_producto_id === "3" ||
      this.state.tipo_producto_id === "4"
    ) {
      this.verifyIngredient(e.target.value);
    }

    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        Swal.fire({
          icon: "warning",
          title: "¡Atención!,",
          text:
            "Principio activo " +
            tipo_control.innerText.toLowerCase() +
            " está " +
            tipo_control.dataset.tipo.toLowerCase(),
        });

        // if (tipo_control.dataset.tipo !== "Controlado") {
        //   e.target.value = "";
        // }
      }
    }

    let rep = { ...this.state.ingrediente };
    let ingrediente_name = this.state.options_ingredientes.find(
      (d) => d.id === e.target.value
    );
    let options_especies = this.state.options_especies;

    if (ingrediente_name) {
      rep["ingrediente_name"] = ingrediente_name.nombre;
    }
    rep["tipo_control"] = tipo_control.dataset.tipo;
    rep[e.target.name] = e.target.value;

    if (tipo_control.dataset.tipo === "Restringido") {
      options_especies = options_especies.filter(
        (obj) => obj.id.toString() !== "1"
      );
    } else {
      options_especies = this.state.options_especies_aux;
    }
    this.setState({ ingrediente: rep, options_especies: options_especies });
  }

  addIngrediente(e) {
    let rep = { ...this.state.ingrediente };
    let pa = [...this.state.ingredientes];
    let dosis = this.state.dosis,
      categorias_restringidas_listadas =
        this.state.categorias_restringidas_listadas,
      especies_restringido_alimento_animal =
        this.state.especies_restringido_alimento_animal,
      ingredientes_listados_restringidos =
        this.state.ingredientes_listados_restringidos;

    if (rep.ingrediente_id !== "") {
      for (let re in pa) {
        if (pa[re].ingrediente_id === rep.ingrediente_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);

      let especies_restringido_alimento_animal_map =
        especies_restringido_alimento_animal.map((obj) => obj.ingrediente_id);

      if (
        especies_restringido_alimento_animal_map.includes(rep.ingrediente_id)
      ) {
        ingredientes_listados_restringidos.push(rep.ingrediente_id);
      }

      let especieSinCat = especies_restringido_alimento_animal.filter(
        (obj) => obj.categoria_id === null
      );

      if (especieSinCat) {
        especieSinCat = especieSinCat.map((obj) => obj.especie_id);
      }

      if (especies_restringido_alimento_animal.length > 0) {
        dosis = dosis.filter(
          (obj) =>
            !categorias_restringidas_listadas.includes(obj.categoria_id) &&
            !especieSinCat.includes(obj.especie_id) &&
            obj.especie_id !== "1"
        );
      }

      this.setState({
        dosis: dosis,
        ingredientes: pa,
        ingrediente: this.initialState.ingrediente,
        ingredientes_listados_restringidos: ingredientes_listados_restringidos,
      });
    }
  }

  removeIngrediente(e) {
    let ingredientes = [...this.state.ingredientes];
    this.getIngredientInfo(ingredientes[e.target.id].ingrediente_id);
    ingredientes.splice(e.target.id, 1);
    this.setState({
      ingredientes: ingredientes,
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ procesando: true });

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };
    // shallow copy is inherit of the main state
    delete postData.options_unidad_medida;
    delete postData.options_ingredientes_activos;
    delete postData.options_ingredientes_excipientes;
    delete postData.options_especies;
    delete postData.options_categoria;
    delete postData.options_empaque;
    delete postData.options_medida_tiempo;
    delete postData.options_forma_farmaceutica;
    delete postData.options_paises;

    let tipo_vet = this.state.tipo_producto_veterinario_id;
    let tipo_producto = this.state.tipo_producto_id;

    if (tipo_producto === "3" || tipo_producto === "4") {
      tipo_vet = "5";
    }

    if (
      this.state.principios_activos.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "3")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un principio activo.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.excipientes.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "3")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un excipiente.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.composiciones_biologicas.length === 0 &&
      tipo_vet === "2"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una composición biológica.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.composiciones_quimicas.length === 0 &&
      tipo_vet === "2"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una composición química.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.analisis.length === 0 && tipo_vet === "5") {
      Swal.fire({
        title: "Es necesario agregar al menos un análisis garantizado.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.ingredientes.length === 0 && tipo_vet === "5") {
      Swal.fire({
        title: "Es necesario agregar al menos un ingrediente.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.empaques.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "2" || tipo_vet === "5")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un envase/empaque.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.componentes.length === 0 && tipo_vet === "4") {
      Swal.fire({
        title: "Es necesario agregar al menos un componente.",
        icon: "error",
      });
    } else if (
      this.state.especies_interes_diagnostico.length === 0 &&
      tipo_vet === "4"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una especie de interés.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.presentaciones.length === 0 && tipo_vet === "4") {
      Swal.fire({
        title: "Es necesario agregar al menos una presentación.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.titular_id === "") {
      Swal.fire({
        title: "Es necesario seleccionar un titular.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.fabricante_id === "") {
      Swal.fire({
        title: "Es necesario seleccionar un fabricante.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else {
      Api.fetch("app/productVetInscription", postData, "POST")
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            this.setState({ procesando: false });
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: "Revise la información e intente de nuevo su última acción.", //message,
            });
          }); //catching errors to show notification
        });
    }
  }

  handleRegister(e) {
    if (e.errors) {
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .toUpperCase()}</li>`;
      }
      tplErrors += `</u>`;
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      this.setState({ procesando: false });
      return false;
    } else {
      Swal.fire({
        title: "Solicitud Generada",
        icon: "success",
        text: "Su solicitud para producto ha sido recibida exitosamente.",
      }).then(() => {
        window.location = "/productos/listado";
      });
    }
    this.setState({ procesando: false });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    const tipo_producto = this.state.tipo_producto_id;
    let Titulo, tipo_forma;
    if (tipo_producto === "1" || tipo_producto === "2") {
      Titulo = "Alta de medicamentos veterinarios";
      tipo_forma = "Forma farmacéutica";
    } else if (tipo_producto === "3" || tipo_producto === "4") {
      Titulo = "Alta de productos para alimentación animal";
      tipo_forma = "Forma de comercialización";
    }

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/form/elements">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/form/elements">Productos</Link>
          </li>
          <li className="breadcrumb-item active">{Titulo}</li>
        </ol>

        <h1 className="page-header">{Titulo}</h1>

        <div className="row" onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form style={{ margin: "3%" }}>
                  <div className="row">
                    <div
                      className={
                        this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2"
                          ? "form-group col-md-12"
                          : "form-group col-md-6"
                      }
                    >
                      <label>Nombre comercial: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="nombre_comercial"
                        maxLength="200"
                        value={this.state.nombre_comercial}
                        //disabled={this.state.disabled}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            nombre_comercial: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4"
                          ? "form-group col-md-6"
                          : "hide"
                      }
                    >
                      <label>Clasificación: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="clasificacion_id"
                        className="form-control m-b-5"
                        value={this.state.clasificacion_id}
                        onChange={(e) =>
                          this.setState({
                            clasificacion_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_clasificacion.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo_producto_id === "1" ||
                      this.state.tipo_producto_id === "2"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="medicamento_veterinario"
                        checked={this.state.tipo === "medicamento_veterinario"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "medicamento_veterinario" })}
                      />
                      Medicamento Veterinario
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="biologico"
                        checked={this.state.tipo === "biologico"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "biologico" })}
                      />
                      Biológico
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="producto_afin"
                        checked={this.state.tipo === "producto_afin"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "producto_afin" })}
                      />
                      Producto Afín
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="reactivos_diagnosticos"
                        checked={this.state.tipo === "reactivos_diagnosticos"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "reactivos_diagnosticos" })}
                      />
                      Reactivos de diagnósticos
                    </div>
                  </div>

                  {/* PRINCIPIO ACTIVO */}
                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="principio_activo"
                  >
                    <div className="form-group col-md-5">
                      Principio activo: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          name="principio_activo_id"
                          className="form-control m-b-5 "
                          onChange={this.handlePrincipioActivo}
                          value={
                            this.state.principio_activo.principio_activo_id
                          }
                        >
                          <option value="" disabled className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_ingredientes_activos.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                                data-tipo={option.descripcion}
                              >
                                {option.nombre}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        name="concentracion"
                        type="number"
                        min={1}
                        maxLength="4"
                        onChange={this.handlePrincipioActivo}
                        value={this.state.principio_activo.concentracion}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handlePrincipioActivo}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.principio_activo.unidad_medida}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addPrincipioActivo}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista principios activos */}

                  <div
                    className={
                      this.state.principios_activos.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaPrincipiosActivos" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Principio activo</th>
                            <th>Concentración</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.principios_activos.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.principio_activo_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  data-categoria_id={reg.categoria_id}
                                  onClick={this.removePrincipioActivo}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    data-categoria_id={reg.categoria_id}
                                    onClick={this.removePrincipioActivo}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* EXCIPIENTE */}

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="excipiente"
                  >
                    <div className="form-group col-md-5">
                      Excipiente: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleExcipiente}
                          name="excipiente_id"
                          className="form-control m-b-5 "
                          value={this.state.excipiente.excipiente_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" disabled className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_ingredientes_excipientes.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                                data-tipo={option.descripcion}
                              >
                                {option.nombre}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        name="concentracion"
                        type="number"
                        min={1}
                        maxLength="4"
                        value={this.state.excipiente.concentracion}
                        onChange={this.handleExcipiente}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div
                        className="row" /* style={{marginRight:"0.09em"}}  */
                      >
                        <select
                          onChange={this.handleExcipiente}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.excipiente.unidad_medida}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addExcipiente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista excipientes */}

                  <div
                    className={
                      this.state.excipientes.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaExcipientes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Excipiente</th>
                            <th>Concentración</th>
                            <th>Unidad medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.excipientes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.excipiente_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeExcipiente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeExcipiente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPOSICION BIOLOGICA */}

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="composicion_biologica"
                  >
                    <div className="form-group col-md-5">
                      Composición biológica:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleComposicionBiologica}
                          name="composicion_biologica_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.composicion_biologica
                              .composicion_biologica_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_composicion_biologica.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Titulo/Unidad de medida:{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="titulo_unidad_medida"
                        value={
                          this.state.composicion_biologica.titulo_unidad_medida
                        }
                        onChange={this.handleComposicionBiologica}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>
                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComposicionBio}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista composicion biologica */}

                  <div
                    className={
                      this.state.composiciones_biologicas.length > 0 &&
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComposicionBiologica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición biológica</th>
                            <th>Titulo/Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.composiciones_biologicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_biologica_name}</td>
                                <td>{reg.titulo_unidad_medida}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={this.removeComposicionBio}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeComposicionBio}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPOSICION QUIMICA */}

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="composicion_quimica"
                  >
                    <div className="form-group col-md-5">
                      Composición química:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleComposicionQuimica}
                          name="composicion_quimica_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.composicion_quimica
                              .composicion_quimica_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_composicion_quimica.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        type="number"
                        name="concentracion"
                        min={1}
                        maxLength="4"
                        value={this.state.composicion_quimica.concentracion}
                        onChange={this.handleComposicionQuimica}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div
                        className="row" /* style={{marginRight:"0.09em"}}  */
                      >
                        <select
                          onChange={this.handleComposicionQuimica}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.composicion_quimica.unidad_medida}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComposicionQuimica}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista composicion quimica */}

                  <div
                    className={
                      this.state.composiciones_quimicas.length > 0 &&
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComposicionQuimica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición química</th>
                            <th>Concentración</th>
                            <th>Unidad medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.composiciones_quimicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_quimica_name}</td>
                                <td>{reg.concentracion}</td>
                                <td>{reg.unidad_medida_name}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={this.removeComposicionQuimica}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeComposicionQuimica}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ANALISIS GARANTIZADO */}

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4"
                        ? "row"
                        : "row hide"
                    }
                    id="analisis"
                  >
                    <div className="form-group col-md-5">
                      Análisis garantizado:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          name="analisis_id"
                          value={this.state.analisis_garantizado.analisis_id}
                          onChange={this.handleAnalisis}
                          className="form-control m-b-5"
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_analisis.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Porcentaje(%): <span className="text-danger">*</span>
                      <input
                        type="number"
                        name="porcentaje"
                        min={1}
                        max={100}
                        value={this.state.analisis_garantizado.porcentaje}
                        onChange={this.handleAnalisis}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addAnalisis}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista ANALISIS GARANTIZADO */}

                  <div
                    className={
                      this.state.analisis.length > 0 &&
                      (this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4")
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaAnalisis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Análisis garantizado</th>
                            <th>Porcentaje(%)</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.analisis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.analisis_name}</td>
                              <td>{reg.porcentaje}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeAnalisis}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeAnalisis}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* INGREDIENTE */}

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4"
                        ? "row"
                        : "row hide"
                    }
                    id="ingredientes"
                  >
                    <div className="form-group col-md-11">
                      Ingrediente: <span className="text-danger">*</span>
                      <select
                        name="ingrediente_id"
                        value={this.state.ingrediente.ingrediente_id}
                        onChange={this.handleIngrediente}
                        className="form-control m-b-5"
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_ingredientes.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                            data-tipo={option.descripcion}
                          >
                            {option.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addIngrediente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista ingredientes */}

                  <div
                    className={
                      this.state.ingredientes.length > 0 &&
                      (this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4")
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaIngredientes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Ingrediente</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.ingredientes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.ingrediente_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeIngrediente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeIngrediente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DOSIS POR ESPECIE */}

                  <div
                    className={
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="dosis_especies_via"
                  >
                    <div className="form-group col-md-5">
                      Dosis por especie y vía de administración:
                      <input
                        type="input"
                        name="dosis"
                        onChange={this.handleDosisEspecie}
                        value={this.state.dosis_especie.dosis}
                        className="form-control m-b-5"
                        //style={{width:"36.3em",resize: "horizontal"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.dosis_especie.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-6"
                      }
                    >
                      Especie destino:
                      <div className="row" style={{ marginLeft: "0.08em" }}>
                        <select
                          onChange={this.handleDosisEspecie}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={this.state.dosis_especie.especie_id}
                          /* style={{ width: "20.5em" }} */
                          //disabled={this.state.esBaja}
                        >
                          <option value="" disabled className="dropdown-item">
                            Seleccione...
                          </option>
                          {(this.state.tipo_producto_id === "1" ||
                            this.state.tipo_producto_id === "2") &&
                          this.state.tipo_producto_veterinario_id === "2"
                            ? this.state.options_especies_aux.map((option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              ))
                            : this.state.options_especies.map((option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.dosis_especie.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-3 hide"
                      }
                    >
                      Categoría:
                      <div className="row">
                        <select
                          onChange={this.handleDosisEspecie}
                          name="categoria_id"
                          id="categoria_id"
                          className="form-control m-b-5"
                          value={this.state.dosis_especie.categoria_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" disabled className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_categoria
                            .filter(
                              (e) =>
                                e.especie_id ===
                                this.state.dosis_especie.especie_id
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                data-categoria={option.descripcion}
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addDosisEspecie}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista dosis */}

                  <div
                    className={
                      this.state.dosis.length > 0 &&
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDosis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Dosis</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.dosis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.dosis}</td>
                              <td>{reg.especie_name}</td>
                              <td>{reg.categoria_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeDosisEspecie}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeDosisEspecie}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* MODO DE EMPLEO POR ESPECIE */}

                  <div
                    className={
                      this.state.tipo === "producto_afin" ? "row" : "row hide"
                    }
                    id="modo_empleo"
                  >
                    <div className="form-group col-md-5">
                      Modo de empleo: <span className="text-danger"></span>
                      <input
                        type="input"
                        name="modo_empleo"
                        onChange={this.handleModoEmpleo}
                        value={this.state.modo_empleo.modo_empleo}
                        className="form-control m-b-5"
                        //style={{width:"36.3em",resize: "horizontal"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.modo_empleo.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-6"
                      }
                    >
                      Especie destino: <span className="text-danger"></span>
                      <div className="row" style={{ marginLeft: "0.08em" }}>
                        <select
                          onChange={this.handleModoEmpleo}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={this.state.modo_empleo.especie_id}

                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_especies.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.modo_empleo.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-3 hide"
                      }
                    >
                      Categoría: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handleModoEmpleo}
                          name="categoria_id"
                          className="form-control m-b-5 "
                          value={this.state.modo_empleo.categoria_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_categoria
                            .filter(
                              (e) =>
                                e.especie_id ===
                                this.state.modo_empleo.especie_id
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                //data-nombre=
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addModoEmpleo}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista modo de empleo */}

                  <div
                    className={
                      this.state.modos_empleo.length > 0 &&
                      this.state.tipo === "producto_afin"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaModoEmpleo" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Modo de empleo</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.modos_empleo.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.modo_empleo}</td>
                              <td>{reg.especie_name}</td>
                              <td>{reg.categoria_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeModoEmpleo}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeModoEmpleo}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* TIPO DE ENVASE */}

                  <div
                    className={
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="envases"
                  >
                    <div className="form-group col-md-5">
                      Tipo de envase/empaque:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleEmpaque}
                          name="empaque_id"
                          className="form-control m-b-5 "
                          value={this.state.empaque.empaque_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_empaque.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/*  <div className="form-group col-md-4">
                     Presentaciones: <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="presentacion"
                        value={this.state.empaque.presentacion}
                        onChange={this.handleEmpaque}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                      </div> */}

                    <div className="form-group col-md-3">
                      Presentaciones cantidad:{" "}
                      <span className="text-danger">*</span>
                      <input
                        name="presentacion_cantidad"
                        type="number"
                        min={1}
                        max={9999999}
                        onChange={this.handleEmpaque}
                        value={this.state.empaque.presentacion_cantidad}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handleEmpaque}
                          name="presentacion_unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.empaque.presentacion_unidad_medida}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addEmpaque}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista empaques */}

                  <div
                    className={
                      this.state.empaques.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaEmpaques" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Empaque</th>
                            {/*  <th>Presentaciones</th> */}
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.empaques.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.empaque_name}</td>
                              {/* <td>{reg.presentacion}</td> */}
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeEmpaque}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeEmpaque}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DESCARTE */}

                  <div
                    className={
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="periodo_descarte"
                  >
                    <div className="form-group col-md-3">
                      Periodo de retiro o descarte:{" "}
                      <span className="text-danger"></span>
                      <input
                        type="number"
                        name="periodo"
                        min={1}
                        maxLength="4"
                        value={this.state.descarte.periodo}
                        onChange={this.handleDescarte}
                        className="form-control m-b-5"
                        //style={{width:"36.3em"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-2">
                      Tiempo: <span className="text-danger"></span>
                      <select
                        name="medida_tiempo_id"
                        className="form-control m-b-5 "
                        value={this.state.descarte.medida_tiempo_id}
                        onChange={this.handleDescarte}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_medida_tiempo
                          .filter(
                            (e) =>
                              e.descripcion === "Días" ||
                              e.descripcion === "Horas"
                          )
                          .map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      Especie producto: <span className="text-danger"></span>
                      <select
                        onChange={this.handleDescarte}
                        name="especie_prod_id"
                        className="form-control  "
                        value={this.state.descarte.especie_prod_id}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_especies_producto.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addDescarte}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista descarte */}

                  <div
                    className={
                      this.state.descartes.length > 0 &&
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDescartes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Periodo</th>
                            <th>Tiempo</th>
                            <th>Especie producto</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.descartes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.periodo}</td>
                              <td>{reg.medida_tiempo_name}</td>
                              <td>{reg.especie_prod_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeDescarte}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeDescarte}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPONENTES */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="componentes"
                  >
                    <div className="form-group col-md-5">
                      Componente: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="input"
                          name="componente"
                          value={this.state.componente.componente}
                          onChange={this.handleComponente}
                          className="form-control m-b-5"
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="concentracion"
                        value={this.state.componente.concentracion}
                        onChange={this.handleComponente}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComponente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista componentes */}

                  <div
                    className={
                      this.state.componentes.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComponentes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Componente</th>
                            <th>Concentración</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.componentes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.componente}</td>
                              <td>{reg.concentracion}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeComponente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeComponente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ESPECIE INTERES DIAGNOSTICO */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="especie_interes_diagnostico"
                  >
                    <div className="form-group col-md-11">
                      Especie de interés diagnóstico:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleEspecieInteres}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.especie_interes_diagnostico.especie_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_especies_aux.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addEspecieInteres}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista especie interes diagnostico */}

                  <div
                    className={
                      this.state.especies_interes_diagnostico.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div
                      id="listaEspecieInteresDiagnostico"
                      className="col-md-12"
                    >
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Especie</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.especies_interes_diagnostico.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.especie_name}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={this.removeEspecieInteres}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeEspecieInteres}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* PRESENTACIONES */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="presentaciones"
                  >
                    {/* <div className="form-group col-md-11">
                      Presentaciones: <span className="text-danger">*</span>
                       <input
                        type="input"
                        name="presentacion"
                        value={this.state.presentacion.presentacion}
                        onChange={this.handlePresentaciones}
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>  */}

                    <div className="form-group col-md-5">
                      Presentaciones cantidad:{" "}
                      <span className="text-danger">*</span>
                      <input
                        name="presentacion_cantidad"
                        type="number"
                        min={1}
                        maxLength="4"
                        onChange={this.handlePresentaciones}
                        value={this.state.presentacion.presentacion_cantidad}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handlePresentaciones}
                          name="presentacion_unidad_medida"
                          className="form-control m-b-5 "
                          value={
                            this.state.presentacion.presentacion_unidad_medida
                          }
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addPresentaciones}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista presentaciones */}

                  <div
                    className={
                      this.state.presentaciones.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaPresentaciones" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.presentaciones.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removePresentaciones}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removePresentaciones}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DETALLES PRODUCTO */}

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="precauciones_generales"
                  >
                    <div className="form-group col-md-12">
                      <label>Precauciones generales:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_generales"
                        value={this.state.precauciones_generales}
                        onChange={(e) =>
                          this.setState({
                            precauciones_generales:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4" ||
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="precauciones_biologico"
                  >
                    <div className="form-group col-md-6">
                      <label>Precauciones de uso:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_uso"
                        value={this.state.precauciones_uso}
                        onChange={(e) =>
                          this.setState({
                            precauciones_uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Precauciones de almacenamiento:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_almacenamiento"
                        value={this.state.precauciones_almacenamiento}
                        onChange={(e) =>
                          this.setState({
                            precauciones_almacenamiento:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-7">
                      Caducidad del producto:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="text"
                          name="caducidad_producto"
                          maxLength="4"
                          value={this.state.caducidad_producto}
                          onChange={this.handleCaducidad}
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-5">
                      Tiempo: <span className="text-danger">*</span>
                      <select
                        name="tiempo"
                        className="form-control m-b-5 "
                        value={this.state.medida_tiempo_id}
                        onChange={(e) =>
                          this.setState({
                            medida_tiempo_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_medida_tiempo.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Forma farmaceutica */}

                  <div className="row">
                    <div
                      className={
                        this.state.tipo !== "reactivos_diagnosticos"
                          ? "form-group col-md-6"
                          : "form-group col-md-6 hide"
                      }
                      id="forma_farmaceutica"
                    >
                      <label>{tipo_forma} </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="forma_farmaceutica_id"
                        className="form-control m-b-5"
                        value={this.state.forma_farmaceutica_id}
                        onChange={(e) =>
                          this.setState({
                            forma_farmaceutica_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_forma_farmaceutica.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={
                        this.state.tipo !== "reactivos_diagnosticos"
                          ? "form-group col-md-6"
                          : "form-group col-md-12"
                      }
                    >
                      <label>País de origen:</label>
                      <span className="text-danger"> *</span>

                      <select
                        name="pais_origen_id"
                        className="form-control m-b-5"
                        value={ this.state.tipo_producto_id === "1" || this.state.tipo_producto_id === "3" ? "1" : this.state.pais_origen_id} //si es nacional
                        onChange={(e) =>
                            this.setState({
                              pais_origen_id: e.target.value,
                            })
                        }
                        required
                        disabled={this.state.tipo_producto_id === "1" || this.state.tipo_producto_id === "3"? true : false } //si es nacional
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_paises.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo !== "biologico" ? "row" : "row hide"
                    }
                    id="indicaciones_uso"
                  >
                    <div className="form-group col-md-12">
                      <label>Indicaciones de uso: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="uso"
                        value={this.state.uso}
                        onChange={(e) =>
                          this.setState({
                            uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="instrucciones_uso"
                  >
                    <div className="form-group col-md-12">
                      <label>Instrucciones de uso: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="instrucciones_uso"
                        value={this.state.instrucciones_uso}
                        onChange={(e) =>
                          this.setState({
                            instrucciones_uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo === "medicamento_veterinario"
                        ? "row"
                        : "row hide"
                    }
                    id="validez_preparacion"
                  >
                    <div className="form-group col-md-12">
                      <label>Validez para preparación extemporánea: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="validez_preparacion"
                        value={this.state.validez_preparacion}
                        onChange={(e) =>
                          this.setState({
                            validez_preparacion: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="propiedades_inmunologicas"
                  >
                    <div className="form-group col-md-12">
                      <label>Propiedades inmunológicas: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="propiedades_inmunologicas"
                        value={this.state.propiedades_inmunologicas}
                        onChange={(e) =>
                          this.setState({
                            propiedades_inmunologicas:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Fabricante: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="fabricante_id"
                        className="form-control m-b-5"
                        value={this.state.fabricante_id}
                        onChange={(e) =>
                          this.setState({
                            fabricante_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.fabricantes.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/*                     <div className="form-group col-md-6">
                      <label>Titular: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="titular_id"
                        className="form-control m-b-5"
                        value={this.state.titular_id}
                        onChange={(e) =>
                          this.setState({
                            titular_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.titulares.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>

                  {/* REPRESENTANTES LEGALES */}

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Representante legal: </label>
                      <span className="text-danger"> *</span>
                      <div
                        id="listaRepresentantes"
                        className={
                          this.state.representantes_legales.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.representantes_legales.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.nombre}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* REGENTES */}

                    <div className="form-group col-md-6">
                      <label>Regentes: </label>
                      <span className="text-danger"> *</span>
                      <div
                        id="listaRegentes"
                        className={this.state.regentes.length > 0 ? "" : "hide"}
                      >
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.regentes.map((reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.nombre}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <div
                    className={
                      this.state.procesando
                        ? "progress rounded-corner m-b-15"
                        : "hide"
                    }
                  >
                    <div
                      className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <h4>Cargando, espere...</h4>
                    </div>
                  </div>

                  <div
                    className={this.state.procesando ? "hide" : "pull-right"}
                  >
                    <div style={{ marginBottom: "10%" }}>
                      <button
                        type="reset"
                        onClick={this.handleReset}
                        className="btn btn-danger m-r-5"
                      >
                        Regresar
                      </button>
                      <button
                        type="submit"
                        onClick={this.handleSubmit}
                        className=" btn btn-success m-r-5"
                      >
                        Generar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  const match = useRouteMatch();
  return <Product auth={auth} history={history} match={match} {...props} />;
};
